// Regex for finding whether the note has agenda in any form available
export const agendaFinderRegex = new RegExp('^agenda[^0-9a-zA-Z]*$', 'i');
